import request from '../utils/request';

export function snVerify(params) {
  return request({
    url: 'subscribe/sn/verify',
    method: 'POST',
    data: params
  })
}

export function subscribe(params) {
  return request({
    url: 'subscribe/upgrade',
    method: 'POST',
    data: params
  })
}

export function getAccountList(params) {
  return request({
    url: 'subscribe/account/list',
    method: 'POST',
    data: params
  })
}

export function sendMail(params) {
  return request({
    url: 'subscribe/mail/send',
    method: 'POST',
    data: params
  })
}




// WEBPACK FOOTER //
// ./src/api/subscribe.js